<div
  id="print-content"
  layout-align="start center"
  class="vi-primary vi-hue-1 print-content no-print-flexbox truespeed-content internal"
>
  <div class="page">
    <div class="page-break"></div>

    <div layout="row" class="report-header">
      <!-- <img src="images/truespeed-logo.png" class="truespeed-logo"> -->
      <img src="/images/viavi-logo-purple.png" class="truespeed-logo" />
      <h2 class="truespeed-title">Application Test Report - VoIP</h2>
    </div>
    <hr />

    <table class="four-column-table">
      <tr>
        <th colspan="4" class="background">Test Request Info</th>
      </tr>

      <tr>
        <td>Technician Name</td>
        <td>{{ selectedReport.technician_name }}</td>
        <td>Technician ID</td>
        <td>{{ selectedReport.technician_ID }}</td>
      </tr>

      <tr>
        <td>Customer Name</td>
        <td>{{ selectedReport.customer_name }}</td>
        <td>Email</td>
        <td>{{ selectedReport.email }}</td>
      </tr>

      <tr>
        <td>Phone</td>
        <td>{{ selectedReport.phone }}</td>
        <td>Company</td>
        <td>{{ selectedReport.company }}</td>
      </tr>

      <tr>
        <td>Test Name</td>
        <td>{{ selectedReport.test_name }}</td>
        <td>Test Type</td>
        <td>{{ selectedReport.test_type }}</td>
      </tr>
      <tr>
        <td>Start Time</td>
        <td>{{ selectedReport.start_time }}</td>
        <td>End Time</td>
        <td>
          {{ selectedReport.end_time }}
        </td>
      </tr>

      <tr>
        <td>DMZ Test URL</td>
        <td colspan="3">{{ selectedReport.dMZ_test_URL }}</td>
      </tr>

      <tr>
        <td>vTA-TS Test URL</td>
        <td colspan="3">{{ selectedReport.vTA_TS_test_URL }} b</td>
      </tr>

      <!-- <tr>
        <td>Auth Code Creation Date</td>
        <td>{{ selectedReport.auth_code_creation_date }}</td>
        <td>Expiration Date</td>
        <td>{{ selectedReport.expiration_date }}</td>
      </tr> -->

      <tr>
        <td>Comments</td>
        <td colspan="3">{{ selectedReport.comments }}</td>
      </tr>
    </table>
  </div>
</div>
